const BaseView = require('components-framework/view/base.view');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const checkinMoreInfoNagFactory = require('components/checkin/checkin_moreinfo_nag/js/main');

const HIDDEN_CLASS = 'odf-hidden';

module.exports = withCachedSelectors(BaseView.extend({

    events: {
        'tap .moreinfo_checkin_funnel_popup': 'startCheckinFunnelPopup',
    },

    selectors: {
        checkinPopupMoreinfoContainer: '.checkin_moreinfo_popup_container',
    },

    initialize() {
        this.el.innerHTML = this.templates.main(this);
        this.showMoreInfoNag();
    },

    showCheckinMoreInfo(show) {
        this.$el.find(this.selectors.checkinPopupMoreinfoContainer).toggleClass(HIDDEN_CLASS, !show);
    },

    startCheckinFunnelPopup() {
        if (Odigeo.AB.isCheckinSBV3Enabled) {
            const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
            window.location.href = `/travel/extras/#checkin/info/${tdToken}/`;
        } else {
            Odigeo.trigger(`${this.name}:startCheckinFunnelPopup`);
        }
    },

    showMoreInfoNag() {
        const modalWidget = this.createMoreInfoNag();
        modalWidget.execute('open');
    },

    createMoreInfoNag() {
        return checkinMoreInfoNagFactory.create({
            parentEl: document.body,
        });
    },
}));
